module.exports = __webpack_public_path__ + "static/about_cropped-805e38d26433853f1c4ece69c217b1a8.jpg";